module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/AdobeStock_441819185_1_low-06ca6f2e5fd8ed8ea458bcb9a084f5b3.mp4";